import Geocode from "react-geocode";

export const getCountryFromPlace = (place) =>
  place.address_components.find((component) =>
    component.types.includes("country")
  )?.long_name;

export const getStateFromPlace = (place) =>
  place.address_components.find((component) =>
    component.types.includes("administrative_area_level_1")
  )?.long_name;

export const getCityFromPlace = (place) =>
  place.address_components.find((component) =>
    component.types.includes("locality")
  )?.long_name ||
  place.address_components.find((component) =>
    component.types.includes("administrative_area_level_2")
  )?.long_name;

export const getCoordinatesFromAddress = async (address) => {
  try {
    const coords = await Geocode.fromAddress(address);
    if (!coords) return "";
    const { lat, lng } = coords.results[0].geometry.location;
    const country = getCountryFromPlace(coords.results[0]);
    const formattedAddress = coords.results[0]?.formatted_address;
    return {
      coords: [lng, lat],
      country,
      formattedAddress,
    };
  } catch (error) {
    return "";
  }
};

export const pathsAreEqual = (path1, path2) => {
  if (path1?.length !== path2?.length) return false;
  return path1.every(
    (point, index) =>
      point.lat === path2[index].lat && point.lng === path2[index].lng
  );
};
